import * as RadixSelect from '@radix-ui/react-select';
import { forwardRef } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

import { SelectIcon } from './SelectIcon';
import { SelectValue } from './SelectValue';

export const selectTrigger = tailwindVariants({
  base: 'flex shrink-0 items-center justify-between gap-2 rounded-4 border ads:border-input border-gray-5 ads:bg-input bg-gray-1 px-2 ads:text-primary text-16 text-gray-12 outline-none focus:ads:ring-focus focus:ring-2 focus:ring-blue-9 disabled:cursor-not-allowed disabled:ads:border-input disabled:border-gray-5 disabled:ads:bg-input disabled:bg-gray-1 disabled:ads:text-placeholder disabled:text-gray-7',
  defaultVariants: {
    size: 'medium',
  },
  variants: {
    size: {
      'extra-large': 'h-12 md:text-16',
      large: 'h-10 md:text-14',
      medium: 'h-8 md:text-14',
      small: 'h-6 md:text-12',
    },
  },
});

export type SelectTriggerVariants = VariantProps<typeof selectTrigger>;
export type SelectTriggerProps = RadixSelect.SelectTriggerProps & SelectTriggerVariants;

export const SelectTrigger = forwardRef<HTMLButtonElement, SelectTriggerProps>(
  ({ children, className, placeholder, size, ...restOfProps }, forwardedRef) => {
    return (
      <RadixSelect.Trigger
        className={selectTrigger({ class: className, size })}
        data-testid="SELECT_TRIGGER"
        {...restOfProps}
        ref={forwardedRef}
      >
        {children ? (
          children
        ) : (
          <>
            <SelectValue data-testid="SELECT_VALUE" placeholder={placeholder} />
            <SelectIcon data-testid="SELECT_ICON" />
          </>
        )}
      </RadixSelect.Trigger>
    );
  },
);

SelectTrigger.displayName = 'SelectTrigger';
